import React, { useEffect, useState } from "react";
import TableComponent from "../../Global Functions/tableComponents";
import { useDispatch, useSelector } from "react-redux";
import {
  listReferralCommission,
  updateReferralCommission,
} from "../../Redux/Actions/referralCommissionAction";
import { columnsReferralCommission } from "../../Global Functions/columnsAntd";

const ListReferralCommission = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const dispatch = useDispatch();

  const fetchDetails = (page, limit) => {
    const payload = {
      page,
      limit,
    };
    dispatch(listReferralCommission(payload));
  };

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { referralCommissions } = useSelector(
    (state) => state.referral_commission || {}
  );

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  useEffect(() => {
    if (referralCommissions?.total) {
      setPagination((prevData) => ({
        ...prevData,
        total: referralCommissions.total,
      }));
    }
  }, [referralCommissions]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchDetails(pagination.current, pagination.pageSize);
  };

  const handleStatusChange = async (record, action) => {
    if (action === "active" || action === "inactive") {
      const payload = {
        id: record._id,
        status: action,
      };
      await dispatch(updateReferralCommission(payload));
    }

    fetchDetails(pagination.current, pagination.pageSize);
  };

  return (
    <TableComponent
      h3heading="Referral Commissions"
      pagination={pagination}
      onChange={handleTableChange}
      columns={columnsReferralCommission(handleStatusChange)}
      buttonhead2={canAdd ? "Add Referral Commission" : null}
      navigateTo2={canAdd ? "/referral_commission/add" : null}
      dataSource={
        Array.isArray(referralCommissions?.data) ? referralCommissions.data : []
      }
    />
  );
};

export default ListReferralCommission;
